import React, { FC, useState } from 'react'
import Dialog from './Dialog'

const PasswordValidation = ({ value, position='top', validationResult, error, children, t }) => {
  const [showDialog, setShowDialog] = useState(false)

  return (
    <div className="container">
      <div className="passwordValidation">
        {children({ showDialog: () => setShowDialog(true), closeDialog: () => setShowDialog(false) })}
        {validationResult !== null && value?.trim()?.length > 0 && 
            <Dialog t={t} position={position} showDialog={showDialog} validationResult={validationResult} />}
      </div>
      {
        error && (
          <div className="error-msg">
            {error}
          </div>
        )
      }
    </div>
  )
}

export default PasswordValidation
